import { useState, useEffect } from "react";

interface UseKakaoLoginReturn {
  isLoading: boolean;
  error: string;
  loginWithKakao: () => void;
  clearError: () => void;
}

declare global {
  interface Window {
    Kakao: any;
  }
}

const useKakaoLogin = (): UseKakaoLoginReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const initKakaoSDK = () => {
      if (window.Kakao && !window.Kakao.isInitialized()) {
        window.Kakao.init(process.env.REACT_APP_KAKAO_JAVASCRIPT_KEY);
      }
    };

    if (!document.getElementById("kakao-sdk")) {
      const script = document.createElement("script");
      script.id = "kakao-sdk";
      script.src = "https://developers.kakao.com/sdk/js/kakao.js";
      script.onload = initKakaoSDK;
      document.head.appendChild(script);
    } else {
      initKakaoSDK();
    }
  }, []);

  const loginWithKakao = () => {
    if (!window.Kakao) {
      setError("카카오 SDK가 로드되지 않았습니다.");
      return;
    }

      setIsLoading(true);
      setError("");

      try {
        // 카카오 로그인 리다이렉트 방식으로 변경
        const state = Math.random().toString(36).substring(2, 15);
        const redirectUri = `${window.location.origin}/auth/kakao/callback`;
        
        window.Kakao.Auth.authorize({
          redirectUri: redirectUri,
          state: state,
        });
    } catch (err: any) {
      console.error("카카오 로그인 오류:", err);
      setError(err.message || "카카오 로그인 중 오류가 발생했습니다.");
      setIsLoading(false);
    }
  };

  const clearError = () => {
    setError("");
  };

  return {
    isLoading,
    error,
    loginWithKakao,
    clearError,
  };
};

export default useKakaoLogin;
